<div class="header_bar" id="results_header_bar">
  <div
    class="brand-title header_bar_nav_left"
    [ngClass]="{ 'brand-title__trim_mobile': hasStandardLogo() }"
  >
    <a
      href="#main"
      accesskey="s"
      class="sr-only sr-only-focusable btn btn-link"
      (click)="focusContainer('main')"
      role="link"
      (keydown.enter)="focusContainer('main')"
      tabindex="0"
      i18n="@@resultsHeaderSkipNavigation"
      >Skip navigation</a
    >
    @if (!basketService.atLeastOneSearchChosen() && !isOnHomePageOrBasket() && !isOnResults()) {
      <a
        class="sr-only sr-only-focusable btn btn-link"
        (click)="focusBasketButton()"
        (keydown.enter)="focusBasketButton()"
        i18n="@@resultsHeaderGoToRecentSearches"
        tabindex="0"
        role="link"
      >
        Skip to Recent Searches
      </a>
    }
    @if ((basketService.atLeastOneSearchChosen() && !isOnHomePageOrBasket()) || isOnResults()) {
      <a
        class="sr-only sr-only-focusable btn btn-link"
        (click)="focusBasketButton()"
        role="link"
        (keydown.enter)="focusBasketButton()"
        i18n="@@resultsHeaderGoToBasket"
        tabindex="0"
      >
        Skip to Basket
      </a>
    }
    <div
      (click)="resetAndBackToSearch()"
      (keydown.enter)="resetAndBackToSearch()"
      tabindex="0"
      role="link"
      aria-label="Return to home"
    >
      <img class="lightningLogoImg" alt="Logo - Return to Home" [src]="logoUrl" />
    </div>
  </div>
  <div class="header_bar_nav_section">
    <div
      class="nav-section-item"
      routerLink="/search"
      routerLinkActive="isActive"
      #newBookingLink="routerLinkActive"
      [attr.aria-current]="newBookingLink.isActive ? 'page' : null"
      id="main-new-booking"
      aria-labelledby="main-new-booking"
      i18n="@@resultHeaderNewBooking"
      role="link"
      (keydown.enter)="resetToNewBooking(); redirect('/search')"
      (click)="resetToNewBooking(); redirect('/search')"
      tabindex="0"
    >
      New Booking
    </div>
    <div
      [routerLinkActiveOptions]="{ exact: true }"
      class="nav-section-item"
      routerLink="/my-bookings"
      routerLinkActive="isActive"
      #myBookingsLink="routerLinkActive"
      [attr.aria-current]="myBookingsLink.isActive ? 'page' : null"
      id="main-my-booking"
      aria-labelledby="main-my-booking"
      i18n="@@resultHeaderMyBooking"
      role="link"
      (keydown.enter)="redirect('/my-bookings')"
      (click)="redirect('/my-bookings')"
      tabindex="0"
    >
      My Bookings
    </div>
    @if (showDTD) {
      <div
        class="nav-section-item"
        routerLink="/door-to-door/search-form"
        routerLinkActive="isActive"
        #doorToDoorLink="routerLinkActive"
        [attr.aria-current]="doorToDoorLink.isActive ? 'page' : null"
        [routerLinkActiveOptions]="{ exact: true }"
        id="main-GetUsThere"
        aria-labelledby="main-GetUsThere"
        role="link"
        (keydown.enter)="redirect('/door-to-door')"
      >
        <span i18n="@@resultHeaderDoortoDoor">Door-to-Door</span>
      </div>
    }
    <!-- ********* -->
    @if (showUsefulInformationDropdown) {
      <div class="nav-section-item">
        <div
          id="Show-Useful-Information"
          title="Show Useful Information"
          i18n-title
          i18n-aria-label
          (click)="displayUsefulLinks()"
          (keydown.enter)="displayUsefulLinks()"
          tabindex="0"
          [attr.aria-expanded]="displayUsefulInformation"
          [attr.aria-label]="
            displayUsefulInformation ? 'Hide Useful Information' : 'Show  Useful Information'
          "
          role="button"
        >
          <span i18n="@@UsefulInfo">Useful Information</span>
          @if (!displayUsefulInformation) {
            <span> <fa-icon [icon]="faChevronDown"></fa-icon></span>
          }
          @if (displayUsefulInformation) {
            <span> <fa-icon [icon]="faChevronUp"></fa-icon></span>
          }
        </div>
        @if (displayUsefulInformation) {
          <div class="useful-info-list-wrapper">
            <ul class="useful-list">
              <li class="useful-list-item selectable_item">
                <div
                  aria-label="Contact"
                  i18n-ngbTooltip
                  (click)="openContactsUrl()"
                  (keydown.enter)="openContactsUrl()"
                  role="link"
                  tabindex="0"
                  i18n="@@Contact"
                >
                  Contact
                </div>
              </li>
              <li class="useful-list-item selectable_item">
                <div
                  aria-label="Feedback and Support"
                  i18n-ngbTooltip
                  (click)="openFeedbackUrl()"
                  (keydown.enter)="openFeedbackUrl()"
                  role="link"
                  tabindex="0"
                  i18n="@@FeedbackPortal"
                >
                  Feedback and Support
                </div>
              </li>
              <li class="useful-list-item selectable_item">
                <div
                  aria-label="User Guides"
                  i18n-ngbTooltip
                  (click)="openUserGuides()"
                  (keydown.enter)="openUserGuides()"
                  role="link"
                  tabindex="0"
                  i18n="@@UserGuides"
                >
                  User Guides
                </div>
              </li>
              <li class="useful-list-item selectable_item">
                <div
                  aria-label="Price Match"
                  i18n-ngbTooltip
                  (click)="openPriceMatch()"
                  (keydown.enter)="openPriceMatch()"
                  role="link"
                  tabindex="0"
                  i18n="@@PriceMatch"
                >
                  Price Match
                </div>
              </li>
            </ul>
          </div>
        }
      </div>
    }
    <!-- ******** -->
  </div>

  @if (overrideTravelPolicy) {
    <div class="nav-disabled-policies">
      <p
        id="main-OverrideTravelPolicy"
        aria-labelledby="main-OverrideTravelPolicy"
        i18n="@@MainAgentsOverrideTravelPolicy"
        tabindex="5"
      >
        All Travel Policies Disabled
      </p>
    </div>
  }

  @if (showSupportEmail()) {
    <div class="header_bar_nav">
      @if (userIsClient()) {
        <button
          appButton="large"
          class="info-button"
          title="Support"
          i18n-title="@@supportTitle"
          id="support"
          aria-label="Support"
          i18n-aria-label="@@supportTitle"
          (click)="openSupport()"
          tabindex="0"
        >
          <i class="ico ico-info-circle"></i>
        </button>
      }
      @if (!userIsClient()) {
        <button
          appButton="large"
          class="support-email"
          title="Support"
          i18n-title="@@supportTitle"
          id="support"
          aria-label="Support"
          i18n-aria-label="@@supportTitle"
          (click)="openSupport()"
          i18n="@@HeaderSupportModal"
          tabindex="0"
        >
          Help
        </button>
      }
      <span class="header_label" aria-hidden="true" i18n="@@HeaderSupportModal"> Help </span>
    </div>
  }

  @if (themeService.isLightningEnv) {
    <div class="header_bar_nav show_mobile">
      <div
        class="beamerTrigger"
        tabindex="0"
        role="button"
        title="What's New"
        i18n-title
        (click)="setBeamerIframeTitle()"
      >
        <fa-icon
          aria-hidden="true"
          [icon]="faBell"
          class="fa-bell-icon"
          i18n="@@BeamerNotificationsButton"
        ></fa-icon>
        <span class="sr-only">Whats new -&nbsp;</span>
        <!-- NEED TO FIGURE OUT HOW TO DISPLAY THE BADGE NUMBER -->
        <!-- <span class="badge rounded-pill badge-notification bg-danger">1</span> -->
      </div>
    </div>
  }

  @if (helpUrl) {
    <div class="header_bar_nav">
      <a
        [href]="helpUrl"
        aria-label="Help"
        target="_blank"
        i18n-ngbTooltip
        title="Userguides, helpful info or to contact us. alt+h."
        i18n-title="@@UserguidesHelpful"
        class="header-buttons help"
        tabindex="0"
      >
        ?
        <span id="aria-help-button" class="header-buttons logout" hidden i18n="@@AriaHelpButton">
          Help
        </span>
      </a>
    </div>
  }

  @if (userIcon) {
    <div class="header_bar_nav user_navitem show_mobile">
      <div
        id="Show-User-Options"
        (click)="displayUserData()"
        (keydown.enter)="displayUserData()"
        tabindex="0"
        [attr.aria-expanded]="display_user_data"
        role="button"
      >
        <div class="circleRow">
          <div class="circle">
            <span>{{ name_initials }}</span>
          </div>
          <div class="user_fullname">{{ user_info?.name }}</div>
          <span class="visuallyhidden">-Show User Options</span>
          <div>
            <fa-icon [icon]="faChevronDown"></fa-icon>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Admin/User functions dropdown -->
  @if (display_user_data) {
    <div class="user_dropdown_container">
      <div class="user_dropdown">
        <ul class="user_dropdown_info">
          <li>{{ user_info.title }} {{ user_info?.name }}</li>
          <li>{{ user_info.email }}</li>
          <li><span i18n="@@UserAccountType">Account Type</span>: {{ user_info.account_type }}</li>
          @if (live) {
            <li i18n="@@BookingsAreLive">Bookings are live</li>
          }
          @if (!live) {
            <li i18n="@@BookingsAreNotLive">Bookings are NOT live</li>
          }
          <li class="profile_information_link">
            <a
              href="#/profile-information"
              (click)="removeIfInvoked()"
              i18n="@@UserProfileInformation"
              >Profile Information</a
            >
          </li>
          <li
            class="languages-wrapper"
            id="Set-User-Language"
            title="Change Language"
            i18n-title
            i18n-aria-label
            (click)="toggleLanguagesState = !this.toggleLanguagesState"
            (keydown.enter)="toggleLanguagesState = !this.toggleLanguagesState"
            [attr.aria-label]="toggleLanguagesState ? 'Hide Languages' : 'Show Languages'"
            tabindex="0"
            [attr.aria-expanded]="toggleLanguagesState"
            role="button"
          >
            <fa-icon [icon]="faLanguage"></fa-icon>
            <span i18n="@@UserLanguages">Languages</span>
            @if (!toggleLanguagesState) {
              <span> <fa-icon [icon]="faChevronDown"></fa-icon></span>
            }
            @if (toggleLanguagesState) {
              <span> <fa-icon [icon]="faChevronUp"></fa-icon></span>
            }
          </li>
          @if (toggleLanguagesState) {
            <div class="languages-list-wrapper">
              <span i18n="@@PleaseSelectYourPreferredLanguage"
                >Please select your preferred language.</span
              >
              @if (availableLanguages && availableLanguages.length) {
                <select
                  appSelect
                  [border]="true"
                  [noIcon]="true"
                  (ngModelChange)="updateLanguage($event)"
                  [(ngModel)]="selectedLanguage.id"
                >
                  @for (language of availableLanguages; track language) {
                    <option [ngValue]="language?.id">
                      {{ language?.name }}
                    </option>
                  }
                </select>
              }
            </div>
          }
          <!-- ****** -->
          @if (showUsefulInformationDropdown) {
            <li
              class="uc-wrapper user_dropdown_item_booking"
              title="Useful Information"
              i18n-title
              i18n-aria-label
              (click)="toggleUsefulInfoState = !this.toggleUsefulInfoState"
              (keydown.enter)="toggleUsefulInfoState = !this.toggleUsefulInfoState"
              [attr.aria-label]="toggleUsefulInfoState ? 'Hide Useful Info' : 'Show Useful Info'"
              tabindex="0"
              [attr.aria-expanded]="toggleUsefulInfoState"
              role="button"
            >
              <span i18n="@@UsefulInfo">Useful Information</span>
              @if (!toggleUsefulInfoState) {
                <span> <fa-icon [icon]="faChevronDown"></fa-icon></span>
              }
              @if (toggleUsefulInfoState) {
                <span> <fa-icon [icon]="faChevronUp"></fa-icon></span>
              }
            </li>
          }
          @if (toggleUsefulInfoState) {
            <div>
              <div
                class="selectable_item user_dropdown_item_booking"
                aria-label="Contact"
                i18n-ngbTooltip
                (click)="openContactsUrl()"
                (keydown.enter)="openContactsUrl()"
                role="link"
                tabindex="0"
                i18n="@@Contact"
              >
                Contact
              </div>
              <div
                class="selectable_item user_dropdown_item_booking"
                aria-label="Feedback and Support"
                i18n-ngbTooltip
                (click)="openFeedbackUrl()"
                (keydown.enter)="openFeedbackUrl()"
                role="link"
                tabindex="0"
                i18n="@@FeedbackPortal"
              >
                Feedback and Support
              </div>
              <div
                class="selectable_item user_dropdown_item_booking"
                aria-label="User Guides"
                i18n-ngbTooltip
                (click)="openUserGuides()"
                (keydown.enter)="openUserGuides()"
                role="link"
                tabindex="0"
                i18n="@@UserGuides"
              >
                User Guides
              </div>
              <div
                class="selectable_item user_dropdown_item_booking"
                aria-label="Price Match"
                i18n-ngbTooltip
                (click)="openPriceMatch()"
                (keydown.enter)="openPriceMatch()"
                role="link"
                tabindex="0"
                i18n="@@PriceMatch"
              >
                Price Match
              </div>
            </div>
          }
        </ul>
        @if (userCarbonAllowance) {
          <div
            class="user_dropdown_item selectable_item"
            target="_blank"
            role="button"
            tabindex="0"
            (click)="showCarbonAllowance = !showCarbonAllowance"
          >
            <span i18n="@@UserCarbonAllowance">Carbon Allowance</span>
            @if (showCarbonAllowance) {
              <div class="carbon-container">
                <div class="flex-row-container flex-column-mobile">
                  <div class="flex-column-container flex-column-container--left left-col">
                    <p>{{ carbonPolicyHeader }}</p>
                    <br />
                    <p>
                      <strong i18n="@@UserCarbonAllowanceRemaining">Remaining:</strong>
                      {{ userCarbonAllowance.remainingCo2 }} Kg
                    </p>
                    <p>
                      <strong i18n="@@UserCarbonAllowanceAllowance">Allowance:</strong>
                      {{ userCarbonAllowance.totalCo2 }} Kg
                    </p>
                  </div>
                  <div class="flex-column-container flex-column-container--left left-col">
                    <p>
                      <strong>{{ startOfPeriod }} - {{ endOfPeriod }}</strong>
                    </p>
                  </div>
                  <!-- <span>{{userCarbonAllowance}}</span> -->
                </div>
              </div>
            }
            @if (showCarbonAllowance) {
              <div class="carbon-arrow"></div>
            }
          </div>
        }
        @if (showLanguages()) {
          <div
            class="user_dropdown_item selectable_item"
            target="_blank"
            role="button"
            tabindex="0"
          >
            <span i18n="@@UserDropdownLanguage">Language Selection</span>
            <app-language-selection></app-language-selection>
          </div>
        }
        @if (isUserAdmin) {
          <div
            class="user_dropdown_item selectable_item"
            (click)="openAdminModal()"
            (keydown.enter)="openAdminModal()"
            (keydown.space)="openAdminModal()"
            target="_blank"
            tabindex="0"
            role="button"
            i18n="@@UserDropdownAdmin"
          >
            User Admin
          </div>
        }
        @if (canBecomeUser && !isSupportAgent) {
          <div
            class="user_dropdown_item selectable_item"
            (click)="openBecomeUserModal()"
            (keydown.enter)="openBecomeUserModal()"
            role="menuitem"
            tabindex="0"
            role="button"
            i18n="@@UserDropdownBecomeUser"
          >
            Become User
          </div>
        }
        @if (isSupportAgent) {
          <div
            class="user_dropdown_item selectable_item"
            (click)="endUserSession()"
            (keydown.enter)="endUserSession()"
            role="menuitem"
            tabindex="0"
            role="button"
            i18n="@@UserDropdownBackToAgencyUser"
          >
            Back to Agency User
          </div>
        }
        <div
          class="user_dropdown_item selectable_item user_dropdown_item_booking"
          (keydown.enter)="resetToNewBooking(); redirect('/search')"
          (click)="resetToNewBooking(); redirect('/search')"
          tabindex="0"
          role="button"
          i18n="@@AriaNewBookingButton"
        >
          New Booking
        </div>
        <div
          class="user_dropdown_item selectable_item user_dropdown_item_booking"
          (keydown.enter)="redirect('/my-bookings')"
          (click)="redirect('/my-bookings')"
          role="menuitem"
          tabindex="0"
          role="button"
          i18n="@@AriaMyBookingsButton"
        >
          My Bookings
        </div>
        @if (showDTD) {
          <div
            class="user_dropdown_item selectable_item user_dropdown_item_booking"
            (keydown.enter)="redirect('/door-to-door')"
            (click)="redirect('/door-to-door')"
            role="button"
            tabindex="0"
            i18n="@@AriaDoortoDoor"
          >
            Door-to-Door
          </div>
        }
        @if (logoutIcon) {
          <div
            class="user_dropdown_item selectable_item"
            (click)="logout()"
            (keydown.enter)="logout()"
            role="menuitem"
            tabindex="0"
            role="button"
            i18n="@@AriaLogoutButton"
          >
            Log Out
          </div>
        }
      </div>
    </div>
  }
</div>
@if (isSupportAgent && user_info.email) {
  <div
    class="become-user-email-container"
    [ngClass]="{ 'become-user-padding': !blank && !isOnHomePage() }"
  >
    <span i18n="@@BecomeUserActive">Become user active</span>: {{ user_info.email }}
  </div>
}
@if (!blank && !isSubHidden) {
  <app-sub-header-bar
    [page]="page"
    [resultsType]="resultsType"
    [basketItemTypes]="basketItemTypes"
  ></app-sub-header-bar>
}
